import CardHolder from './card-holder.vue';

export default CardHolder;
